import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { login, logout, selectIsAuthenticated } from '../store/slices/authSlice';
import { useAppDispatch, useAppSelector } from '../store/store';

// Custom hook for auth actions
export const useAuth = () => {
  const dispatch = useAppDispatch();
  const { user, token } = useAppSelector(state => state.auth);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      const response = await authService.logout();
      dispatch(logout());
      // Redirect to login
      navigate('/', { replace: true });
      return response;
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleLogin = async (credentials: { email: string; password: string }) => {
    try {
      const response = await authService.login(credentials);
      dispatch(login(response));
      return response;
    } catch (error) {
      const errorMsg = error instanceof Error ? error.message : 'Login failed';
      throw errorMsg;
    }
  };

  return {
    user,
    token,
    isAuthenticated,
    login: handleLogin,
    logout: handleLogout,
    hasRole: (role: string) => user?.role === role,
  };
};
